import React from 'react'

import PrimaryHeader from '../primary-header'
import Title from '../title'
import Icon from '../icon'

import * as S from './styles'

import IProps from './props'

import LinkBuilder from '../../helpers/helper-link-builder'

import userIMG from '../../assets/png/user-profile.png'

const ContractorProfileHeader = ({ contractor, showIcon, onClick }: IProps) => (
  <PrimaryHeader>
    <Title>Voltar</Title>
    <S.Content>
      <S.Avatar
        src={
          contractor.imgUrl
            ? LinkBuilder.buildAssetsUrl(contractor.imgUrl)
            : userIMG
        }
        alt="Avatar"
      />

      <div>
        {' '}
        <S.Name>
          {contractor.corporateName}
          {showIcon && <Icon name="edit-hollow" onClick={onClick} />}
        </S.Name>
        <S.ContractorInfo>
          <S.InfoDetails
            to={{
              pathname: LinkBuilder.buildMailtoLink(contractor.email as string),
            }}
            target="_blank"
          >
            <Icon name="email" />
            <S.Info>{contractor.email}</S.Info>
          </S.InfoDetails>
          <S.InfoDetails
            to={{
              pathname: LinkBuilder.buildWhatsAppLink(
                contractor.phone as string,
              ),
            }}
            target="_blank"
          >
            <Icon name="whatsapp" />
            <S.Info>{contractor.phone}</S.Info>
          </S.InfoDetails>
        </S.ContractorInfo>
      </div>
    </S.Content>
    <S.EditImageLink to="/edit-profile-image/contractor">
      Editar foto
    </S.EditImageLink>
  </PrimaryHeader>
)

export default ContractorProfileHeader
